export const orgSteps = [
  {
    number: "1",
    title: "Define Your Challenge",
    description: "Share your problem statement and goals, whether it involves sourcing data, building models, or improving existing solutions."
  },
  {
    number: "2",
    title: "Engage Global Talent",
    description: "Host a quest to attract AI/ML experts and choose who can participate—whether it's open to all or limited to a selected group."
  },
  {
    number: "3",
    title: "Evaluate and Implement",
    description: "Review submissions and integrate the best solutions into your business."
  },
  {
    number: "4",
    title: "Retain Full Ownership",
    description: "Maintain control over your data, solutions, and intellectual property."
  }
]; 